module.exports = __webpack_public_path__ + "static/media/noclass9.a1545226.png";